<div class="sidebar" role="dialog">
	<app-sidebar-header [title]="'extrasSidebar.findHotels.title.chooseRoom' | ibeadmin | async" [label]="hotel?.hotelInfo?.hotel_name">
		<div actions><button class="button button--small" (click)="INDRA_save()" *ngIf="INDRA_hasRoomSelections()"
			[attr.aria-label]="'extrasSidebar.findHotels.aria.confirmChanges' | ibeadmin | async">{{ 'extrasSidebar.findHotels.button.done' | ibeadmin | async }}</button></div>
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable low-contrast sidebar-wrapper" #sidebar__body>

		<div class="hotel-block__edit-top" *ngIf="edit">
			<h1 class="title-h1 hotel-block__edit-title bottom-gap">{{ 'extrasSidebar.findHotels.text.yourSelection' | ibeadmin | async }} </h1>
			<button class="button full-width button-main-line button--mobile-full" [attr.aria-label]="'extrasSidebar.findHotels.text.changeHotel' | ibeadmin | async" (click)="INDRA_changeHotel()">
				{{ 'extrasSidebar.findHotels.text.changeHotel' | ibeadmin | async }}
				</button>
			<hr class="separator top-gap bottom-gap">
		</div>


		<div class="hotel-block__top">
			<div class="hotel-block__title">
				<h2 class="title-h2">{{ hotel?.hotelInfo?.hotel_name }} </h2>
				<div class="hotel-block__rating" *ngIf="INDRA_hasStars( hotel )">
					<app-svg class="hotel-block__rating-star" [alt]="'Rating star'" svg="sprite.svg#misc--rating-star--full"
						*ngFor="let star-full of INDRA_printStar('full', hotel)"  aria-hidden=false [attr.aria-label]="INDRA_printStar('full', hotel) + ' stars rating'"></app-svg>
				</div>
			</div>
			<div class="hotel-block__score" *ngIf="INDRA_hasStars( hotel )">
				{{ hotel?.hotelInfo?.review_score_word }} {{ hotel?.hotelInfo?.review_score }}
			</div>
		</div>
		<div class="hotel-block__location" *ngIf="hotel && hotel.hotelInfo.address">
			{{ INDRA_printAddres() }} <a href="javascript:;" [attr.aria-label]="'extrasSidebar.findHotels.aria.showHotelAddress' | ibeadmin | async" role="button" (click)="INDRA_showMap()" class="link">{{ 'extrasSidebar.findHotels.text.showMap' | ibeadmin | async }}</a>
		</div>
		<app-simple-gallery [photos]="photosGallery"></app-simple-gallery>
		<hr class="separator">
		<div class="grid no-padding" *ngIf="hotel?.hotelData?.hotel_description">
			<div class="col-12 col-tp-12 col-p-12 hotel-block__description">
				{{ INDRA_hotelDescription( hotel?.hotelData?.hotel_description ) }}
				<a href="javascript:;" role="button" [attr.aria-label]="'extrasSidebar.findHotels.aria.showHotelDetails' | ibeadmin | async" (click)="INDRA_truncate()" *ngIf="truncate" class="link">{{ 'extrasSidebar.findHotels.text.allHotelDetails' | ibeadmin | async }}</a>
			</div>
		</div>

		<div *ngIf="!edit; else editView">
			<div class="room-block" *ngFor="let room of rooms; let roomIndex = index">
				<div class="room-block__top">
					<div class="room-block__top__image" *ngIf="room.image">
						<img alt="Hotel room image" src="{{ room.image }}">
					</div>
					<div class="room-block__top__description">
						<div class="room-block__top__description__title">{{ room.name }}</div>
						<p class="muted"> {{ 'extrasSidebar.findHotels.text.max' | ibeadmin | async }} {{ room.maxOccupancy }} {{ 'extrasSidebar.findHotels.text.guests' | ibeadmin | async }}</p> <!-- {{ room.bed_count }} beds, --> 

						<a href="javascript:;" role="button" class="link"  [attr.aria-label]="'extrasSidebar.findHotels.aria.toggleDisplay' | ibeadmin | async" (click)="INDRA_seeCommodities(room)" [ngClass]="{ 'is-active': room.seeCommodities }">
							{{room.seeCommodities ? ('extrasSidebar.findHotels.link.hide' | ibeadmin | async) : ('extrasSidebar.findHotels.link.see' | ibeadmin | async) }} {{ 'extrasSidebar.findHotels.link.roomCommodities' | ibeadmin | async }}</a>
					</div>
				</div>
				<div class="room-block__description" [ngClass]="{ 'is-active': room.seeCommodities }">
					{{ room.description }}
					<p class="room-block__description__title">{{ 'extrasSidebar.findHotels.text.roomCommodities' | ibeadmin | async }}:</p>
					<ul class="room-block__description__list unordered-list">
						<li *ngFor="let facility of room.facilities">{{ facility }}</li>
					</ul>
				</div>
				<ng-container *ngFor="let roomOption of room.roomOptions; let roomOptionIndex = index">
					<div class="room-block__rooms" [ngClass]="{ 'is-active': roomOption.selected > 0 }">
						<ng-container>
							<div class="room-block__rooms-price">
								<app-svg class="room-block__rooms-price__icon" *ngIf="roomOption.maxOccupancy > 1"
									[alt]="'Couples icon'" svg="icons.svg#general--couple" aria-hidden=”true”></app-svg>
								<app-svg class="room-block__rooms-price__icon" *ngIf="roomOption.maxOccupancy === 1"
									[alt]="'Single star'" svg="icons.svg#general--single" aria-hidden=”true”></app-svg>
								<div class="room-block__rooms-price__price">
									<p>{{ roomOption.price | indracurrency: INDRA_getCurrencyUnit(roomOption.currency) }}</p>
									<span>{{ 'extrasSidebar.findHotels.text.for' | ibeadmin | async }} {{ roomOption.nights }} {{ 'extrasSidebar.findHotels.text.night' | ibeadmin | async }}</span>
								</div>
							</div>
							<div class="room-block__rooms-type">
								<div class="room-block__rooms-type__bed">{{ INDRA_getRoomOccupancy(roomOption.maxOccupancy) }}
								</div>
								<div class="room-block__rooms-type__commodities">
									{{ roomOption.refundable ? ('extrasSidebar.findHotels.text.refundable' | ibeadmin | async) : ('extrasSidebar.findHotels.text.notRefundable' | ibeadmin | async) }}</div>
							</div>
							<div class="room-block__rooms-beds">
								<div class="select-wrapper">
									<!-- span class="select-placeholder" *ngIf="!INDRA_getNumberOfRooms(roomIndex)" aria-hidden="true" >0 rooms</span-->
									<label class="label visuallyhidden" [attr.for]="'room-' + roomIndex + '-' + roomOptionIndex">{{ 'extrasSidebar.findHotels.text.selectRooms' | ibeadmin | async }}</label>
									<select class="select" [attr.aria-label]="'extrasSidebar.findHotels.aria.selectQuantity' | ibeadmin | async" [attr.id]="'room-' + roomIndex + '-' + roomOptionIndex" placeholder="0 rooms"
										[(ngModel)]="roomOption.selected">
										<option aria-label="0 room" selected="selected" [ngValue]="0">0 {{ 'extrasSidebar.findHotels.text.room' | ibeadmin | async }}</option>
										<option aria-label="1 room" [ngValue]="1">1 {{ 'extrasSidebar.findHotels.text.room' | ibeadmin | async }}</option>
									</select>
								</div>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</div>

		<ng-template #editView>
			<div class="room-block" *ngFor="let room of rooms; let roomIndex = index">
				<div class="room-block__top">
					<div class="room-block__top__image" *ngIf="room.image">
						<img src="{{ room.image  }}" alt="selected hotel room image">
					</div>
					<div class="room-block__top__description">
						<div class="room-block__top__description__title">{{ room.name }}</div>
						<p class="muted">{{ 'extrasSidebar.findHotels.text.max' | ibeadmin | async }} {{ room.maxOccupancy }} {{ 'extrasSidebar.findHotels.text.guests' | ibeadmin | async }}</p> <!-- {{ room.bed_count }} beds,  -->

						<a href="javascript:;" role="button" class="link"  [attr.aria-label]="'extrasSidebar.findHotels.aria.toggleDisplay' | ibeadmin | async" (click)="INDRA_seeCommodities(room)" [ngClass]="{ 'is-active': room.seeCommodities }">
							{{room.seeCommodities ? ('extrasSidebar.findHotels.link.hide' | ibeadmin | async) : ('extrasSidebar.findHotels.link.see' | ibeadmin | async) }} {{ 'extrasSidebar.findHotels.link.roomCommodities' | ibeadmin | async }}</a>
					</div>
				</div>
				<div class="room-block__description" [ngClass]="{ 'is-active': room.seeCommodities }">
					{{ room.description }}
					<p class="room-block__description__title">{{ 'extrasSidebar.findHotels.text.roomCommodities' | ibeadmin | async }}:</p>
					<ul class="room-block__description__list">
						<li *ngFor="let facility of room.facilities">{{ facility }}</li>
					</ul>
				</div>
				<ng-container *ngFor="let roomOption of room.roomOptions">
					<div class="room-block__rooms" [ngClass]="{ 'is-active': roomOption.selected > 0 }"
						*ngIf=" roomOption.selected > 0 ">
						<ng-container>
							<div class="room-block__rooms-price">
								<app-svg class="room-block__rooms-price__icon" *ngIf="roomOption.maxOccupancy > 1"
										[alt]="'Couples icon'" svg="icons.svg#general--couple" aria-hidden=”true”></app-svg>
								<app-svg class="room-block__rooms-price__icon" *ngIf="roomOption.maxOccupancy === 1"
										[alt]="'Single star'" svg="icons.svg#general--single" aria-hidden=”true”></app-svg>
								<div class="room-block__rooms-price__price">
									<p>{{ roomOption.price | indracurrency: INDRA_getCurrencyUnit(roomOption.currency) }}</p>
									<span>{{ 'extrasSidebar.findHotels.text.for' | ibeadmin | async }} {{ roomOption.nights }} {{ 'extrasSidebar.findHotels.text.night' | ibeadmin | async }}</span>
								</div>
							</div>
							<div class="room-block__rooms-type">
								<div class="room-block__rooms-type__bed">{{ INDRA_getRoomOccupancy(roomOption.maxOccupancy) }}
								</div>
								<div class="room-block__rooms-type__commodities">
									{{ roomOption.refundable ? ('extrasSidebar.findHotels.text.refundable' | ibeadmin | async) : ('extrasSidebar.findHotels.text.notRefundable' | ibeadmin | async) }}</div>
							</div>
							<div class="room-block__rooms-beds">
								{{roomOption.selected }} {{ 'extrasSidebar.findHotels.text.room' | ibeadmin | async }}
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>

			<div class="align-center">
				<button class="button full-width button-main-line button--mobile-full bottom-gap" [attr.aria-label]="'extrasSidebar.findHotels.aria.changeHotel' | ibeadmin | async" (click)="INDRA_changeHotel()">
					{{ 'extrasSidebar.findHotels.button.changeHotel' | ibeadmin | async }}
				</button>

				<a class="link top-gap bottom-gap" href="javascript:;" [attr.aria-label]="'extrasSidebar.findHotels.aria.removeSelections' | ibeadmin | async" (click)="INDRA_RemoveHotel()">
					{{ 'extrasSidebar.findHotels.button.removeHotel' | ibeadmin | async }}
				</a>
			</div>
		</ng-template>

		<ng-container *ngIf="hasError">
			<div class="container">
				<app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" 
					[title]="'extrasSidebar.title.internalError' | ibeadmin | async">
					<div message>
						<span>
							{{ 'extrasSidebar.errorMessage.internalErrorOccured' | ibeadmin | async }}
						</span>
					</div>
				</app-notification>
			</div>
		</ng-container>

		<div #sidebar__footer class="sidebar__footer" *ngIf="!edit && INDRA_hasRoomSelections()">
			<div class="sidebar__footer-actions">
				<button class="button full-width" type="submit" (click)="INDRA_save()" [attr.aria-label]="'extrasSidebar.findHotels.button.done' | ibeadmin | async">{{ 'extrasSidebar.findHotels.button.done' | ibeadmin | async }}</button>
			</div>
		</div>

	</div>
</div>
